import React, { Component } from 'react';

import "./Creditor.scss"
import data from "../../api/data.json"
import CreditOption from "./components/CreditOption/CreditOption"
import CreditChecklist from "./components/CreditChecklist/CreditChecklist"

class Creditor extends Component {
    constructor() {
        super();
        this.optionClick = this.optionClick.bind(this);
        this.state = {
            currValue: 0,
            isCalcActive: "calc"
        }
    }
    optionClick(event) {
        if (event.target.value > 0) {
            this.setState({
                currValue: event.target.value,
                isCalcActive: "calc active"
            });
            if (event.target.value !== this.state.currValue) {
                window.dataLayer.push({
                    'event': 'GA_Event',
                    'Category': 'Isracard',
                    'Action': 'Calculator',
                    'Label': event.target.value
                });
            }
        }
        if (event.target.value < 1) {
            this.setState({
                currValue: event.target.value,
                isCalcActive: "calc"
            });
        }

    }
    getCheckList() {
        return data.creditor.benefits.map((item, index) =>
            <CreditChecklist key={index.toString()} item={item} />
        );
    }
    getItems() {
        return data.creditor.calc.options.map((item, index) =>
            <CreditOption key={index.toString()} item={item} />
        );
    }
    render() {
        return (
            <section className="section section-creditor">
                <div className="padding">
                    <div className="headline">
                        <h4>
                            {data.creditor.headline}
                        </h4>
                    </div>
                    <div className="logo"></div>
                    <div className="linebreak"></div>
                    <div className="desc">
                        <h5>{data.creditor.desc}</h5>
                    </div>
                    <a href={data.creditor.readmore.link} title="" target="_blank" >
                        <div className="credit"></div></a>
                    <div className="checklist">
                        {this.getCheckList()}
                    </div>
                    <div className="readmore">
                        <div className="text">
                            {data.creditor.readmore.teaser}
                        </div>
                        <a href={data.creditor.readmore.link} title="" target="_blank" >
                            <div className="button">
                                <div className="label">
                                    {data.creditor.readmore.button}
                                    <div className="arrow"></div>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div className={this.state.isCalcActive}>
                        <div className="padding">
                            <div className="calclogo"></div>
                            <div className="text">
                                <h3>{data.creditor.calc.headline}</h3>
                                <h4>{data.creditor.calc.desc}</h4>
                            </div>
                            <div className="selectbox" onClick={this.optionClick}>
                                <select name="discount" id="discount" onChange={this.optionClick}>
                                    {this.getItems()}
                                </select>
                            </div>
                            <div className="discount">
                                <div className="disnum">{this.state.currValue}%</div>
                                <div className="distext" dangerouslySetInnerHTML={{ __html: data.creditor.calc.discount }}></div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default Creditor;



// WEBPACK FOOTER //
// ./src/components/Creditor/Creditor.js